import React from "react";
import { Button } from "antd";
import { FaChevronLeft } from "react-icons/fa";

export const HeaderCourse = ({ event, title }) => {
  return (
    <div className={"event-pride-approve-header"}>
      <Button onClick={event} type="default" shape={"square"}>
        <FaChevronLeft />
      </Button>
      <h2 className={"course-view-title"}>{title}</h2>
    </div>
  );
};
